// extracted by mini-css-extract-plugin
export default {"container":"style_container__86R7-","rotation":"style_rotation__lDzs3"};